export default __webpack_public_path__ + "static/media/device_manager_logo.699f7c96.png";